import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';

import Awards from 'components/BKantarciAwards/Awards';

function ResearchAwards() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  return (
    <>
    {isMobile ? ( 
      <>
        <MobileNavbar /> 
        <Awards/>
        <hr />
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <Awards/>
        <hr />
        <Footer />
      </>
    )}
    </>
  );
}

export default ResearchAwards;
